<template>
    <div class="row">
        <div class="col-8 d-flex mb-2" v-if="isInitialized">
            <el-select class="filter-select mr-2 " v-model="filters.regions" multiple collapse-tags placeholder="Filter by region" clearable @change="changeFilters()">
                <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + '(' + item.total + ')'" :value="item.value" />
            </el-select>
            <el-select class="filter-select mr-2 " v-model="filters.countries" multiple collapse-tags placeholder="Filter by countries" clearable @change="changeFilters()">
                <el-option v-for="item in filterOptions.countries" :key="item.value" :label="item.text + '(' + item.total + ')'" :value="item.value" />
            </el-select>
            <el-select class="filter-select mr-2 " v-model="filters.application_year" multiple collapse-tags placeholder="Filter by year" clearable @change="changeFilters()" v-if="!isFilterByYearDisabled">
                <el-option v-for="item in filterOptions.application_year" :key="item.value" :label="item.text + '(' + item.total + ')'" :value="item.value" />
            </el-select>
                 
        </div>
        
        <div class="col-4 mb-2">
             <base-button @click="exportAwarded()" type="primary" size="md" class="btn-fill text-right  mr-2">
                Export Applications
            </base-button>
        </div>
        <div class="col-12" v-if="isInitialized">
            <tabs ref="tab-grants" type="info" @activate-tab="activateTab" square>
                <tab-pane :id="'grants_' + grant.grantId" :label="grant.description" v-for="grant in grants" v-bind:key="grant.grantId">
                    <div class="row d-flex">
                        <div class="col-lg-3" v-for="(application) in applications" :key="application.application_id">
                            <card>
                                <template slot="header">
                                    <h3 class="card-title">{{ grant.description }}</h3>
                                    <h4 class="card-title">{{ application.reference }}</h4>
                                </template>
                                <div>
                                    <router-link :to="{ name: 'Edit Monitoring', params: { grantId: application.grant_id, applicationId: application.application_id }}">
                                        <base-button type="primary" size="lg" simple>VIEW</base-button>
                                    </router-link>
                                </div>
                            </card>
                        </div>
                    </div>
                </tab-pane>
            </tabs>
        </div>
    </div>
</template>
<script>
    import {MonitoringService, GrantService, ExportService} from '@/services';
    import {TabPane, Tabs} from 'src/components';
    import {Select, Option} from 'element-ui';

    export default
    {
        components:
        {
            TabPane,
            Tabs,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data()
        {
            return {
                isInitialized: false,
                grants: [],
                applications: [],
                currentGrantId: 0,
                filters: {},
                filterOptions: {},
                isFilterByYearDisabled:false,
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            await GrantService.all().then((response) =>
            {
                vm.grants = response.data;

                if (vm.currentGrantId === 0)
                {
                    vm.currentGrantId = vm.grants[0].grantId;
                }
            });

            await vm.getFilters();
            await vm.getApplications();

            vm.isInitialized = true;

            loader.hide();
        },
        methods:
        {
            async getFilters()
            {
                const vm = this;

                await MonitoringService.getFilters(
                {
                    grant_id: vm.currentGrantId,
                    regions: vm.filters.regions,
                    countries: vm.filters.countries,
                    application_year:vm.filters.application_year,
                }).then((response) =>
                {
                    vm.filterOptions = response.data;
                });
            },
            async getApplications()
            {
                const vm = this;
                const loader = vm.$loading.show();
                const response = await MonitoringService.getAwardedApplications(
                {
                    grant_id: vm.currentGrantId,
                    regions: vm.filters.regions,
                    countries: vm.filters.countries,
                    application_year:vm.filters.application_year,
                });

                if (response)
                {
                    vm.applications = response.data;
                }

                loader.hide();
            },
            async changeFilters()
            {
                const vm = this;

                await vm.getFilters();
                await vm.getApplications();
            },
            async exportAwarded()
            {
                const vm = this;
                const loader = vm.$loading.show();

                await ExportService.exportAwarded({
                }).then(function (response)
                {
                    if (response.data && response.data.success)
                    {
                        window.open(response.data.url, '_blank');
                    }
                });

                loader.hide();
            },
            activateTab(ev)
            {
                const vm = this;

                vm.currentGrantId = +ev.id.replace('grants_', '');
                if(vm.currentGrantId!=2||vm.currentGrantId!=3)
                    {this.isFilterByYearDisabled=true;}
                if(vm.currentGrantId==2||vm.currentGrantId==3) {this.isFilterByYearDisabled=false;}
                vm.getFilters();
                vm.getApplications();
            },
        },
    };
</script>
<style lang="scss">
    .filters-holder
    {
        margin-left: -10;
        z-index: 10;
    }
</style>
